<template>
   <div id="app">
        <div id="Return_Bar">
            <i class="el-icon-arrow-left"></i>
                <div @click="isreturn" class="isreturn">返回</div>
            </div>
        <div id="text">
                <iframe
                    id="iframeOperationRecord"
                    ref="iframeOperationRecordi"
                    frameborder="no"
                    scrolling="yes"
                    allowfullscreen="true"
                    width="100%"
                    height="100%"
                    :src="QiannuiiframeURL"
                >
                    您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
                </iframe>
        </div>
           
    </div>
</template>

<script>
export default {
    name:'OperationRecord',
    data() {
        return{
            type:this.$route.query.type,
            id:this.$route.query.id,
            QiannuiiframeURL:''//内嵌地址
        }
    },
    created(){
        this.Gorecord()
    },
    methods: {
        isreturn() {
            this.$router.go(-1)
        },
        Gorecord() {
            if (this.type == 'primary'
                || this.type == 'middle'
                || this.type == 'high'
                || this.type == 'aftersaleprimary'
                || this.type == 'aftersalemiddle'
                || this.type == 'aftersalehigh'
                || this.type == 'fbt'){
                this.QiannuiiframeURL = '/cloudtraining/customer/sceneRecords?pageName=clouding&pageTitle=模拟练习&id=' + this.id;
            }
        },
    }
}
</script>
<style lang='less' scoped >
#app {
  height: 100%;
  box-sizing: border-box;
  background: #f6f5f8;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
  background: #fff;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
}
.isreturn {
  color: #262626;
  cursor: pointer;
  margin-top: 2px;
}
.timestyle{margin: 0 20px;height: 28px;line-height: 28px;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/newservice/OperationRecord.vue